<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

@if (label) {
  <p-floatLabel [variant]="floatLabelVariant">
    <bs-autocomplete
      bsFloatLabelCompat
      inputId="companyCountry"
      class="col-grow"
      [ngModel]="selectedCountry"
      (ngModelChange)="selectedCountry = $event"
      [items]="countriesSuggestions"
      [dropdown]="true"
      [requireSelection]="true"
      [disabled]="disabled"
      [minLength]="2"
      [openOnFocus]="true"
      [displayWith]="getDisplayName"
      [compareWith]="compareByName"
      [inputClass]="'company-country-border-0'"
      (queryChange)="onQueryChange($event)"
      (selected)="onSelectCountry()"
      (cleared)="onClear()"
      (blurred)="onBlur($event)" data-testid="selected-country-autocomplete">
    </bs-autocomplete>
    <label for="companyCountry">{{ label }}</label>
  </p-floatLabel>
} @else {
  <bs-autocomplete
    inputId="companyCountry"
    class="col-grow"
    [ngModel]="selectedCountry"
    (ngModelChange)="selectedCountry = $event"
    [items]="countriesSuggestions"
    [dropdown]="true"
    [requireSelection]="true"
    [disabled]="disabled"
    [minLength]="2"
    [openOnFocus]="true"
    [displayWith]="getDisplayName"
    [compareWith]="compareByName"
    [inputClass]="'company-country-border-0'"
    (queryChange)="onQueryChange($event)"
    (selected)="onSelectCountry()"
    (cleared)="onClear()"
    (blurred)="onBlur($event)" data-testid="selected-country-autocomplete-2">
  </bs-autocomplete>
}


